module.exports = __webpack_public_path__ + "media/images/bnet-logo-white-9ed224c7.svg";